export default axios => ({

  device(session_id, deviceId) {
    return axios.get(`/session/${session_id}/result/device/${deviceId}`);
  },
  post(session_id, payload) {
    return axios.post(`/session/${session_id}/result/diagnostic`, payload);
  },
  edit(session_id, payload) {
    return axios.post(`/session/${session_id}/result/diagnostic/batch`, payload);
  },
  fileDownload(id) {
    return axios.get(`/file/download/${id}`, {
      responseType: 'blob'
    })
  },
  fileView(id) {
    return axios.get(`/file/view/${id}`)
  }

})


